<div class="card">
	<div class="card-header">
		<h1>Carga de CSV</h1>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col-md-4" *ngFor="let file of files; let i = index">
				<div class="inin-container" ng-class="file.show2nd?'up-ctn2':'up-ctn'">
					<form>
						<div *ngIf="file.id==10" class="form-group col-md-12">
							<h4 class="align-text-center" style="font-size: 18px">{{file.name}}</h4>
						</div>
						<div *ngIf="file.id!=10" class="form-group col-md-12">
							<h4 class="align-text-center">{{file.name}}</h4>
						</div>
						<div class="form-group col-md-12">
							<a class="inin-cta-btn up-btn center-block" [href]="file.templateUrl"
								[download]="file.fileName"><i class="fa fa-download" aria-hidden="true"></i> Descargar
								Plantilla</a>
						</div>
						<div *ngIf="file.show2nd" class="form-group col-md-12">
							<a class="inin-cta-btn up-btn center-block" [href]="file.templateUrl2" target="_blank"
								[download]="file.fileName2"><i class="fa fa-download" aria-hidden="true"></i> Descargar
								Manual</a>
						</div>
						<div class="form-group col-md-12" *ngIf="!file.uploadFile">
							<button class="btn btn-info center-block" type="file" (click)="selectFile(i)"
								ngf-pattern="'.csv,.xlsx'" accept=".csv,.xlsx" ngf-max-height="1000"
								ngf-max-size="20MB"><i class="fa fa-folder-open" aria-hidden="true"></i> Seleccionar
								Archivo</button>
							<input type="file" id="file{{i}}" name="file{{i}}" style="display: none;"
								(change)="onFileChange($event, file)">
						</div>
						<div class="form-group col-md-12" *ngIf="file.uploadFile">
							<app-loading-button [object]="file.button" [logo]="true" [colorLoading]="'white'"
								(clicked)="upload(file)"></app-loading-button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</div>
<app-modal-error-list *ngIf="errors" [errors]="errors" (close)="errors = null;"></app-modal-error-list>